import React from 'react'

export default function MarkdownLogo() {
    return (
        <div>
            <svg width="30" height="18" viewBox="0 0 30 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_398_5010)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.74291 1.40625C2.35302 1.40625 2.03694 1.72105 2.03694 2.10938V15.8906C2.03694 16.2789 2.35302 16.5938 2.74291 16.5938H27.8755C28.2654 16.5938 28.5815 16.2789 28.5815 15.8906V2.10938C28.5815 1.72105 28.2654 1.40625 27.8755 1.40625H2.74291ZM0.625 2.10938C0.625 0.944399 1.57322 0 2.74291 0H27.8755C29.0452 0 29.9934 0.944399 29.9934 2.10938V15.8906C29.9934 17.0556 29.0452 18 27.8755 18H2.74291C1.57322 18 0.625 17.0556 0.625 15.8906V2.10938Z"
                        fill="currentColor"
                    />
                    <path
                        d="M4.85938 13.7812V4.21875H7.68326L10.5071 7.73438L13.331 4.21875H16.1549V13.7812H13.331V8.29688L10.5071 11.8125L7.68326 8.29688V13.7812H4.85938ZM22.5087 13.7812L18.2728 9.14062H21.0967V4.21875H23.9206V9.14062H26.7445L22.5087 13.7812Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_398_5010">
                        <rect width="29.3684" height="18" fill="white" transform="translate(0.625)" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}
